<template>
  <div
    class="box-onlineShop"
    @click="submitButton(info.id)"
    style="cursor: pointer"
  >
    <!-- <img src="@/assets/image 203.png" alt="" /> -->
    <img v-complete:src="info.platform_image" alt="" />
    <!-- <div class="box-p"> -->
    <p style="cursor: pointer">{{ info.shop_name }}</p>
    <p>{{ info.certificate_number }}476839567487</p>
    <!-- <p>2024年9月10日</p> -->
    <p>{{ dayjs(info.create_time * 1000).format("YYYY-MM-DD") }}</p>
    <!-- </div> -->
  </div>
</template>

<script setup>
import { reactive } from "vue";
import dayjs from "dayjs";
import { useRouter, useRoute } from "vue-router";

const router = useRouter();

const route = useRoute();

const mydata = reactive({
  path: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

const props = defineProps({
  path: {
    type: String,
    // default: "",
  },
  info: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

//按钮点击事件
function submitButton(id) {
  router.push({
    path: props.path,
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.box-onlineShop {
  width: 165px;
  // height: 177px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;

  border-radius: 8px;
  padding: 16px 12px;
  //   border: 1px solid red;
  background-color: #ffffff;
  box-shadow: 0px 5px 40px 0px #0000000d;
  img {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    display: block;
  }
  // .box-p {
  p:nth-of-type(1) {
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    line-height: 24px;
    // margin: 0 auto;
    text-align: center !important;
    margin-top: 8px;
    margin-bottom: 6px;
    display: block;
    white-space: nowrap; //不折行
    text-overflow: ellipsis; //文本溢出 用省略号显示
    overflow: hidden;
  }
  p:nth-of-type(2),
  p:nth-of-type(3) {
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    text-align: center !important;
    display: block;
    white-space: nowrap; //不折行
    text-overflow: ellipsis; //文本溢出 用省略号显示
    overflow: hidden;
  }
}
p:nth-of-type(1):hover {
  color: #009de0;
}

// }
</style>